<template>
    <div>
        <Loading :visible="loading"></Loading>
        <teleport to="#modal">

            <Modal v-model:visible="visible" :backdrop="true">
                <template #main>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Descrizione">
                        <textarea
                            class="border mb-3 border-next-dark-gray"
                            rows="3" v-model="note">
                        </textarea>
                        </Field>
                    </div>
                    <div v-show="!currentEditingIsAttivita" class="flex flex-col mb-3">
                        <Field field_name="Attività">
                            <VueMultiselect
                                :options="attivitaTimesheetAutocomplete.options"
                                v-model="attivitaTimesheetAutocomplete.selection"
                                :loading="attivitaTimesheetAutocomplete.isLoading"
                                @search-change="attivitaTimesheetAutocomplete.search"
                                class="mb-3 next-vue-multiselect-single"
                                :close-on-select="true"
                                :clear-on-select="false"
                                label="descrizione"
                                track-by="id"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                            >
                            </VueMultiselect>
                        </Field>
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-end">
                        <NextButton @click="close" variant="outline-secondary" class="w-44 py-1 px-2 mr-2">Chiudi
                        </NextButton>
                        <NextButton @click="addDescription" variant="outline-primary"
                                    class="w-44 py-1 px-2">Salva
                        </NextButton>
                    </div>
                </template>
            </Modal>
        </teleport>
        <input ref="empty" class="h-0 w-0 outline-none">
        <table class="hidden lg:table border-collapse border w-full table-auto relative">
            <thead class="sticky bg-white border border-next-light-gray z-10"
                   style="top:calc(var(--top-navigation-height))">
            <tr>
                <th></th>
                <th class="border">Sottoprogetto</th>
                <th class="border">Titolo</th>
                <th class="border">Cliente</th>
                <th class="border w-20" v-for="(d,i) in WeekDays" :key="i">{{ d.format('dd D') }}</th>
                <th class="border">Totale progetto</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="(r,i) in rows" :key="r.id" :class="{'hidden': r.hidden}">
                <td class="text-center">
                    <Star class="text-yellow-500" :starred="r.starredByUser"
                          @click="handleStar(r, isRecordAttivita(i))"></Star>
                </td>
                <td v-if="isRecordSottoprogetto(i)" class="border bg-next-bri whitespace-nowrap">{{ r.cod_nodo }}</td>
                <td v-if="isRecordAttivita(i)" colspan="3" class="border bg-next-pro">{{ r.descrizione }}</td>
                <td v-if="isRecordSottoprogetto(i)" class="border">{{ r.titolo }}</td>
                <td v-if="isRecordSottoprogetto(i)" class="border">{{ r.committente_denominazione }}</td>
                <td class="border" v-for="(d,j) in WeekDays">
                    <div class="relative flex items-stretch">
                        <input type="text" class="w-20 bg-transparent focus:bg-white" @keydown.esc="focusOut"
                               :value="getInputValue(i,j)" @change="onChangeTime($event,i,j)" @input="validateInput">
                        <i class="icon-info absolute right-0 cursor-pointer self-center"
                           :class="{'text-next-orange': hasExtraData(i,j)}"
                           @click="openModal(i,j)"></i>
                    </div>
                </td>
                <td class="border w-20">{{ timeToFormat(TotaleProgetto(i)) }}</td>
            </tr>
            <tr>
                <td colspan="4" class="border relative">
                    <div class="w-full" v-show="!showAutocomplete" @click="openAutocomplete">
                        Aggiungi attività
                    </div>
                    <VueMultiselect
                        ref="select"
                        @keydown.esc="$refs.select.deactivate()"
                        @close="showAutocomplete = false"
                        v-show="showAutocomplete"
                        :internal-search="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        class="next-vue-multiselect-single"
                        placeholder="Sottoprogetto/Attività"
                        deselectLabel="Deseleziona"
                        selectedLabel="Selezionato"
                        selectLabel="Seleziona"
                        track-by="id"
                        :options="sottoprogetto_attivita_options"
                        @search-change="onSearchSottoprogettoAttivita"
                        v-model="sottoprogetto_attivita_selection">
                        <template v-slot:singleLabel="{option}">

                            <span v-if="isSottoprogetto(option)" class="text-sm">
                                {{ option.cod_nodo }}
                            </span>
                            <span v-else class="text-sm">
                                {{ option.descrizione }}
                            </span>
                        </template>

                        <template v-slot:option="{option}">

                            <span v-if="isSottoprogetto(option)" class="text-sm flex flex-col">
                                <span>Cod: {{ option.cod_nodo }}</span>
                                <span>BU: {{ option.bu_label }}</span>
                                <span>Titolo: {{ option.titolo }}</span>
                                <span>Cliente: {{ option.committente_denominazione }}</span>
                            </span>
                            <span v-else class="text-sm flex flex-col">
                                <span>Attività: {{ option.descrizione }}</span>
                            </span>
                        </template>
                    </VueMultiselect>
                </td>
            </tr>
            </tbody>
            <tfoot class="sticky bg-white border border-next-light-gray z-10"
                   style="bottom: 0;">
            <tr>
                <th class="border" colspan="4">Totale attività</th>
                <th class="border" v-for="(d,i) in WeekDays">{{ timeToFormat(TotaleGiorno(i)) }}</th>
                <th class="border"></th>
            </tr>
            </tfoot>
        </table>

    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import moment, {relativeTimeRounding} from "moment";
import sottoProgettiManager from "@/api/SottoProgetti";
import Autocomplete from "@/setup/Autocomplete";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import timesheetManager from "@/api/Timesheet";
import ModalInput from "@/components/ModalInput.vue";
import Modal from "@/components/Modal.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import attivitaTimesheetManager from "@/api/SottoprogettoAttivitaTimesheet";
import {mapGetters} from "vuex";
import Loading from "@/components/Loading.vue";
import Star from "@/components/Star.vue";
import {starrableManager} from "@/api/StarrableManager";

@Options({
    name: 'TimesheetTable',
    components: {
        Star,
        Loading,
        NextButton,
        Field,
        Modal,
        ModalInput,
    },
    props: {
        date: String,
        records: Array,
        loading: Boolean,
    },
    computed: {
        ...mapGetters([
            'me',
        ])
    },
    emits: ['error']
})
export default class TimesheetTable extends Vue {
    sottoprogettoAutocomplete: any = setup(() => Autocomplete(sottoProgettiManager, false))
    attivitaAutocomplete: any = setup(() => Autocomplete(attivitaTimesheetManager, false, {ge: 1, co: 1}))
    attivitaTimesheetAutocomplete: any = setup(() => Autocomplete(attivitaTimesheetManager, false, {sp: 1}))
    me!: any
    date!: any
    records!: any
    visible = false
    loading!: boolean
    showAutocomplete = false

    sottoprogetto_attivita_options: any = []
    sottoprogetto_attivita_selection = null

    onSearchSottoprogettoAttivita(search: string) {
        Promise.all([
            this.sottoprogettoAutocomplete.search(search),
            this.attivitaAutocomplete.search(search)
        ]).then(() => {
            this.sottoprogetto_attivita_options.splice(
                0,
                this.sottoprogetto_attivita_options.length,
                // devo filatrare gli elementi gia presenti
                ...this.sottoprogettoAutocomplete.options.filter(
                    (e: any) => {
                        return !this.usedSottoprogettiIds.includes(e.id)
                    }
                ).map((e: any) => {
                    return {...e, type: 'S'}
                }),
                ...this.attivitaAutocomplete.options.filter(
                    (e: any) => {
                        return !this.usedAttivitaIds.includes(e.id)
                    }
                ).map((e: any) => {
                    return {...e, type: 'A'}
                })
            )
        })
    }


    note = ''
    attivita = null
    row_edit_idx: number = -1
    col_edit_idx: number = -1

    numberRegex = "\\d+([.,]\\d+)?"
    hR = `(?<ore>${this.numberRegex})`
    mR = `(?<min>${this.numberRegex})`

    hmr = new RegExp(`${this.hR}\\s+${this.mR}`)
    hmd = new RegExp(`${this.hR}\\s*\:\\s*${this.mR}`)
    hmrs = new RegExp(`${this.hR}h\\s*${this.mR}[m]?`)
    hrs = new RegExp(`${this.hR}h`)
    mrs = new RegExp(`${this.mR}m`)
    hr = new RegExp(`${this.hR}`)

    rows: any[] = []

    matrixValue: any[] = []
    saveTimeout: number = 0

    openAutocomplete() {
        this.showAutocomplete = true
        //@ts-ignore
        this.$refs.select.activate()
    }

    hasExtraData(row_idx: number, col_idx: number) {
        const ts = this.timesheet(row_idx, col_idx)
        if (this.isRecordAttivita(row_idx)) {
            return ts?.note
        }
        return ts?.note || ts?.attivita_timesheet_id
    }

    getRecordData(row_idx: number) {
        return this.rows[row_idx]
    }

    get currentEditingRecordData() {
        return this.getRecordData(this.row_edit_idx)
    }

    isRecordAttivita(row_idx: number) {
        const rr = this.getRecordData(row_idx)
        return this.isAttivita(rr)
    }

    isRecordSottoprogetto(row_idx: number) {
        const rr = this.getRecordData(row_idx)
        return this.isSottoprogetto(rr)
    }

    isSottoprogetto(data: any) {
        return data.type && data.type == 'S'
    }

    isAttivita(data: any) {
        return data.type && data.type == 'A'
    }

    created() {
        //scelgo soli i progetti per cui ho un costo per la bu
        this.sottoprogettoAutocomplete.addAjaxParam('ots', 1)
        this.sottoprogettoAutocomplete.addAjaxParam('per_page', 40)
        this.sottoprogettoAutocomplete.addAjaxParam('sort', '-data_inizio')
    }

    @Watch('sottoprogetto_attivita_selection')
    sottoprogetto() {
        if (this.sottoprogetto_attivita_selection) {
            this.rows.push(this.sottoprogetto_attivita_selection)
            this.matrixValue.push({}, {}, {}, {}, {}, {}, {})
            this.sottoprogettoAutocomplete.empty()
            this.attivitaAutocomplete.empty()
            this.sottoprogetto_attivita_selection = null
        }
        this.showAutocomplete = false
    }

    focusOut() {
        (this.$refs.empty as HTMLInputElement).focus()
    }

    close() {
        this.note = ''
        this.attivitaTimesheetAutocomplete.emptyAll()
        this.visible = false
    }

    addDescription() {
        const ts = this.timesheet(this.row_edit_idx, this.col_edit_idx)
        ts.note = this.note
        if (this.currentEditingIsAttivita) {
            ts.attivita_timesheet_id = this.getRecordData(this.row_edit_idx).id
            ts.sottoprogetto_id = null
        } else {
            ts.attivita_timesheet_id = this.attivitaTimesheetAutocomplete.selection?.id || null
            ts.sottoprogetto_id = this.currentEditingRecordData.id
        }
        this.save(this.getDateFromColumnIndex(this.col_edit_idx), ts).then((res) => {
            this.close()
        })
    }

    get currentEditingIsAttivita() {
        return this.isRecordAttivita(this.row_edit_idx)
    }

    openModal(row_idx: number, col_idx: number) {
        const ts = this.timesheet(row_idx, col_idx)
        this.note = ts ? ts.note : ''

        if (this.isRecordSottoprogetto(row_idx)) {
            this.attivitaTimesheetAutocomplete.empty()
            this.attivitaTimesheetAutocomplete.addAjaxParam('bu', this.rows[row_idx].business_unit_id)
            if (ts && ts.attivita_timesheet_id) {
                attivitaTimesheetManager.retrieve(ts.attivita_timesheet_id).then((res) => {
                    this.attivitaTimesheetAutocomplete.emptyAll()
                    this.attivitaTimesheetAutocomplete.add(res.data)
                }).catch(() => {
                    this.attivitaTimesheetAutocomplete.empty()
                })
            }
        }

        this.row_edit_idx = row_idx
        this.col_edit_idx = col_idx
        this.visible = true
    }

    startWeek() {
        return moment(this.date).startOf('week').clone()
    }

    @Watch('records')
    dateChange() {
        this.rows = JSON.parse(JSON.stringify(this.records))
        const startDate = this.startWeek()
        const new_matrix: any[] = []
        this.rows.forEach((sp: any, row_idx: number) => {
            sp.timesheets.forEach((ts: any) => {
                const col_idx = moment(ts.giorno).diff(startDate, 'days')
                if (col_idx >= 0 && col_idx < 7) {
                    new_matrix[row_idx * 7 + col_idx] = {...ts, format: this.timeToFormat(ts.minuti)}
                }
            })
        })
        for (let i = 0; i < this.rows.length * 7; i++) {
            new_matrix[i] = new_matrix[i] || {}
        }
        this.matrixValue.splice(0, this.matrixValue.length, ...new_matrix);
    }

    get usedSottoprogettiIds() {
        return this.rows.filter((r: any) => r.type === 'S').map((r: any) => {
            return r.id
        })
    }

    get usedAttivitaIds() {
        return this.rows.filter((r: any) => r.type === 'A').map((r: any) => {
            return r.id
        })
    }

    getInputValue(row: number, col: number) {
        const v = this.timesheet(row, col)
        return v?.format ?? ''
    }

    timesheet(row: number, col: number) {
        return this.matrixValue[row * 7 + col]
    }

    get WeekDays() {
        const ret = []
        moment.locale('it')
        for (let i = 0; i < 7; i++) {
            ret.push(this.startWeek().add(i, 'days'));
        }
        return ret
    }

    TotaleProgetto(row: number) {
        return this.subprojectData(row)
            .reduce((acc, v) => {
                return acc + (v?.minuti ?? 0);
            }, 0)
    }

    TotaleGiorno(col: number) {
        let somma = 0;
        let i = col
        while (i < this.matrixValue.length) {
            const v = this.matrixValue[i]
            somma += (v?.minuti ?? 0);
            i += 7;
        }
        return somma;
    }

    subprojectData(index: number) {
        return this.matrixValue.slice(index * 7, index * 7 + 7)
    }

    validateInput($event: any) {
        let minuti = this.parseMinuti($event.target.value)
        if (!minuti && $event.target.value.length) {
            $event.target.classList.add('!bg-next-orange-ring');
        } else {
            $event.target.classList.remove('!bg-next-orange-ring');
        }
    }

    onChangeTime($event: any, row_idx: number, col_idx: number) {
        const original = this.getInputValue(row_idx, col_idx)
        $event.target.classList.remove('border-2', 'border-next-orange');
        const value = $event.target.value
        let val = 0
        if (value.length) {
            let minuti = this.parseMinuti($event.target.value)
            val = minuti
            if (minuti) {
                $event.target.value = this.timeToFormat(minuti)
            }
        }
        if ((value.length == 0 && val == 0) || (value.length != 0 && val > 0)) {
            const ts = this.timesheet(row_idx, col_idx)
            ts.format = this.timeToFormat(val)
            ts.minuti = val
            if (this.isRecordAttivita(row_idx)) {
                ts.attivita_timesheet_id = this.getRecordData(row_idx).id
                ts.sottoprogetto_id = null
            } else {
                ts.attivita_timesheet_id = this.attivitaTimesheetAutocomplete.selection?.id || null
                ts.sottoprogetto_id = this.getRecordData(row_idx).id
            }
            this.save(this.getDateFromColumnIndex(col_idx), ts).then((res: any) => {
                this.$emit('error', null)
                if (res.status == 204) {
                    this.$emit('refreshRequired');
                }
            }).catch((e) => {
                $event.target.classList.add('border-2', 'border-next-orange');
                this.$emit('error', `Impossibile salvare alcuni dati del timesheet: ${e.response?.data?.error}`)
            })
        } else {
            $event.target.value = original
            $event.target.classList.remove('!bg-next-orange-ring');
        }
    }

    getDateFromColumnIndex(col: number) {
        return this.startWeek().add(col, 'days').format('YYYY-MM-DD')
    }

    get pendingSave() {
        return this.saveTimeout !== 0
    }

    save(data: string, ts: any) {
        return timesheetManager.create({
                giorno: data,
                sottoprogetto_id: ts.sottoprogetto_id,
                minuti: ts.minuti,
                note: ts.note,
                attivita_timesheet_id: ts.attivita_timesheet_id
            }
        ).then((res) => {
            this.saveTimeout = 0
            return res
        })
    }

    parseMinuti(value: string) {
        let ore = 0
        let minuti_totali = 0
        let minuti = 0

        let match = null

        if (this.hmr.test(value)) {
            match = value.match(this.hmr)
        } else if (this.hmd.test(value)) {
            match = value.match(this.hmd)
        } else if (this.hmrs.test(value)) {
            match = value.match(this.hmrs)
        } else if (this.hrs.test(value)) {
            match = value.match(this.hrs)
        } else if (this.mrs.test(value)) {
            match = value.match(this.mrs)
        } else if (this.hr.test(value)) {
            match = value.match(this.hr)
        } else {
            return minuti_totali
        }

        ore = parseFloat(match?.groups?.ore?.replace(',', '.') || '0')
        minuti = parseFloat(match?.groups?.min?.replace(',', '.') || '0')

        minuti_totali = Math.ceil(Math.min(minuti + ore * 60, 1440))

        return minuti_totali
    }

    minutesToDict(minute: number) {
        return {ore: Math.floor(minute / 60), minuti: minute % 60, minuti_totali: minute}
    }

    timeToFormat(minuti: number) {
        const dict = this.minutesToDict(minuti)
        if (dict.ore && dict.minuti) {
            return `${dict.ore}h ${dict.minuti}m`
        } else if (dict.ore) {
            return `${dict.ore}h`
        } else if (dict.minuti) {
            return `${dict.minuti}m`
        }
        return ''
    }

    handleStar(record: any, is_attivita: boolean) {
        record.starredByUser = !record.starredByUser
        starrableManager.toggleStar(record.id, is_attivita ? 'attivita' : 'sottoprogetto').then((res) => {
            record.starredByUser = res.data
        }).catch(() => {
            record.starredByUser = !record.starredByUser
        })
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
